module.exports = __webpack_public_path__ + "static/media/16UNODC4.a4455024.jpg";